import React from 'react';
import { Button, CircularProgress } from 'material-ui';
import i18n from '../../services/i18n.js';
import { getAvailability } from '../../services/availabilityService.js';
import { globalPopUpWidget } from '../PopUpDialogController.js';
import { getCMSConfiguration, getLabels } from '../cmsLib.js';
import { assignMarketToRequest } from '../../components/MarketAPI';
import { trackEvent } from '../../services/gaService.js';
import moment from 'moment';
/**
 * Componente AbstractWidget Abstracto para definir funciones comunes.
 * @author Luciano Bustos
 */
class AbstractWidget extends React.Component {
    constructor(props, pName) {
        super(props);
        this.state = {
            actionLoading: false,
            dialogOpen: false,
        };
    }

    getLabels(labels, type) {
        return getLabels(labels, type);
    }

    onClickAction = (e, action) => {
        if (action && action.type === 'SearchAvailability') {
            this.getHotelSelectionTab();
        }
        if (this['action' + action.type]) {
            this['action' + action.type](action)
        } else {
            alert(action.type + ' not implemented');
        }
    }

    getHotelSelectionTab = () => {
        const siteTabs = getCMSConfiguration()['tabs'];
        const hotelTab = siteTabs.find(s => s.type.id === 'H');
        localStorage.setItem('selectedTab', JSON.stringify(hotelTab));
    }

    actionPopUpAction = (action) => {
        //alert(action.type);
        globalPopUpWidget('cmsPopUpDialog', action);
    }

    actionOpenUrlAction = (action) => {
        window.open(action.document.url);
    }

    actionOpenLandingAction = (action) => {
        if (window.location.href.indexOf('preview') !== -1) {
            alert('You\'re in preview mode');
            return;
        }
        let params = {banner_promotion_order: action.parentOrder + ',' + action.order}
        if(action.image && action.image.url){
            params['banner_image_url'] = action.image.url;
        }
        trackEvent('banner_clicked', params);
        window.location.href = `#/promotions/${action.parentOrder},${action.order}`;
    }

    getDateFromString = (dateString) => {
        
        const format = 'DD/MM/YYYY';

        if (!dateString) {
            return moment().format(format);
        }

        return moment(dateString, 'YYYY-MM-DD').format(format);
    }

    actionSearchAvailability = (action) => {
        console.log({action});
        if (window.location.href.indexOf('preview') !== -1) {
            alert('You\'re in preview mode');
            return;
        }
        this.setState({
            actionLoading: true
        });
        let avreq = action.hotelAvailabilityRequest;
        let thedate = this.getDateFromString(avreq.fixedDate);
        let options = {
            'checkInDate': thedate,
            'nights': avreq.numberOfNights || 1,
            'rooms': [
                {
                    'adults': avreq.numberOfAdults || 2,
                    'kids': this.getKids(avreq.ages),
                    'mealPlan': avreq.board || 'ALL'
                }
            ]
        };
        //si tengo un solo hotel.
        if (avreq.id) {
            options.hotels = [avreq.id];
        }
        //si tengo varios hoteles
        if (avreq.hotels) {
            options.hotels = avreq.hotels;
        }
        if (avreq.coast) {
            options.countryCode = avreq.coast;
            options.coastCode = avreq.coast;
        }
        else {
            if (avreq.country) {
                options.countryCode = avreq.country;
            }
            if (avreq.countryDivision) {
                options.stateCode = avreq.countryDivision;
            }
            if (avreq.city) {
                options.townCode = avreq.city;
            }
        }

        if (avreq.rating) {
            options.category = avreq.rating;
        }
        if (avreq.board) {
            options.mealPlan = avreq.board;
        }

        assignMarketToRequest(options);

        let scope = this;
        var asyncWrapper = async () => {
            try {
                const result = await getAvailability(options);
                if (result && result.requestCode) {
                    localStorage.setItem(result.requestCode, JSON.stringify(result));
                    window.location.href = '/#/results/hotels/' + result.requestCode;
                }
            } catch (error) {
                alert(error.message + '\n' + (error.detailedMessage || ''));
            }
            scope.setState({
                actionLoading: false
            });
        };
        asyncWrapper();
    }

    getKids = (ages) => {
        if (ages && ages.length) {
            return ages.map(a => {
                return { age: a };
            });
        }
        return [];
    }

    getAction = (widget) => {
        let action = widget && widget.action ? widget.action.type : 'noaction';
        let label = i18n.t('CMSACTIONS.' + action);
        return action !== 'noaction' ? <Button
            onClick={(e) => this.onClickAction(e, widget.action)}
            className="cmsButtonSearch outlined"
            disabled={this.state.actionLoading || window.location.href.indexOf("#/preview") !== -1}>
            {this.state.actionLoading ?
                <CircularProgress size={22} style={{ color: 'inherit' }} /> : <span style={{ width: '14px' }}></span>
            }
            {label}</Button> :
            <span></span>;
    }
}
export default (AbstractWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/AbstractWidget.js